import { PropsWithChildren, ReactNode } from 'react';
import { GridProps as MuiGridProps } from '@mui/material/Grid/Grid';
import { MuiGrid } from '../../../../../modules/material';
import { StyledMainContent, StyledSection } from './styles';

export enum MarginVariants {
  default = 'default',
  small = 'small',
  extraSmall = 'extraSmall',
}

export interface SectionProps extends Omit<MuiGridProps, 'title'> {
  marginVariant?: keyof typeof MarginVariants;
  rightColumn?: ReactNode;
  showEmptyRightColumn?: boolean;
  contentId?: string;
}

export default function Section(props: PropsWithChildren<SectionProps>) {
  const {
    marginVariant = MarginVariants.default,
    rightColumn,
    showEmptyRightColumn,
    contentId,
    children,
    ...gridContainerProps
  } = props;
  const isRightColumn = showEmptyRightColumn || rightColumn;

  return (
    <StyledSection marginVariant={marginVariant}>
      <MuiGrid
        columnSpacing={{ xs: 0, md: isRightColumn ? 5 : 0 }}
        container
        {...gridContainerProps}
      >
        <StyledMainContent
          item
          xs={12}
          md={isRightColumn ? 8 : 12}
          rightColumn={rightColumn}
          marginVariant={marginVariant}
          id={contentId}
        >
          {children}
        </StyledMainContent>

        {isRightColumn && (
          <MuiGrid item xs={12} md={4}>
            {rightColumn}
          </MuiGrid>
        )}
      </MuiGrid>
    </StyledSection>
  );
}
